// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"361":"9b392331","511":"ab2b07ec","767":"2dbf84f0"}[chunkId] + ".chunk.js");